import React, { type FC, type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Spinner from '@atlaskit/spinner';
import authenticateUsingAppLinks from '@atlassian/jira-common-authenticate-using-app-links/src/index.tsx';
import type { AppLink } from '@atlassian/jira-servicedesk-knowledge-services/src/types.tsx';
import type { AppLinkError } from '../../../state/entities/applink/types.tsx';
import AppLinkErrorPanel from '../applink-error-panel/index.tsx';
import AuthenticationPanel from './authentication-panel/index.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const SpinnerContainer = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: '100%',
	height: '100%',
});

export type Props = {
	children: ReactNode;
	appLinkOrError: AppLink | AppLinkError | undefined;
	onAuthComplete: (error?: Error) => void;
};

export const AppLinkAuthenticationView: FC<Props> = ({
	appLinkOrError,
	children,
	onAuthComplete,
}) => {
	if (!appLinkOrError) {
		return (
			<SpinnerContainer>
				<Spinner size="large" delay={300} />
			</SpinnerContainer>
		);
	}
	// @ts-expect-error - TS2339 - Property 'error' does not exist on type 'AppLink | AppLinkError'.
	if (appLinkOrError.error) {
		return <AppLinkErrorPanel />;
	}
	// @ts-expect-error - TS2339 - Property 'requireCredentials' does not exist on type 'AppLink | AppLinkError'.
	if (appLinkOrError.requireCredentials) {
		const onAuthenticate = async () => {
			try {
				// @ts-expect-error - TS2339 - Property 'authUrl' does not exist on type 'AppLink | AppLinkError'.
				await authenticateUsingAppLinks(appLinkOrError.authUrl);
				onAuthComplete();
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				onAuthComplete(error);
			}
		};
		return <AuthenticationPanel onAuthenticate={onAuthenticate} />;
	}

	return children;
};

export default AppLinkAuthenticationView;
